import Restart16 from '@carbon/icons-react/es/restart/16';
import { Moment } from 'moment';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'components/atoms/button';
import { mondayOfWeek } from './utils';

interface Props {
  currentDate: Moment;
  onResetToDefaultWeek: (nextDate: Moment) => void;
}
export const ReturnToCurrentWeek: FC<Props> = ({
  currentDate,
  onResetToDefaultWeek,
}) =>
  currentDate.isSame(mondayOfWeek(), 'day') ? null : (
    <Button
      size="small"
      type="text"
      icon={<Restart16 />}
      onClick={() => onResetToDefaultWeek(mondayOfWeek())}
    >
      <FormattedMessage id="this_week" />
    </Button>
  );
